// extracted by mini-css-extract-plugin
module.exports = {"cursor":"Mouse_cursor__2gC9i","hover":"Mouse_hover__15ull","focus":"Mouse_focus__3mrlX","cursorRing":"Mouse_cursorRing__2xFf6"};